export enum MessageEventType {
  CHANGEVIDEO = 'CHANGEVIDEO',
  PROGRESS = 'PROGRESS',
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
  READY = 'READY',
  ENDED = 'ENDED',
}

export type MediaData = {
  code: string;
  title: string;
  duration: number;
  percent_watched: number;
  current_time: number;
  aggregate_time_watched: number;
  aggregate_percent_watched: number;
};

export type MessageEventData = {
  id: string;
  event: MessageEventType;
  media?: MediaData;
};
